<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "BaseAdmin",
};
</script>

<style></style>
